import React from 'react';
import { BookOpen, FileText, SparklesIcon, CheckCircle2Icon } from 'lucide-react';
export function WhatIsIncludedSection() {
  const tomos = [{
    num: 1,
    title: 'Tarot desde Cero',
    desc: 'Bases del tarot, estructura del mazo, cómo empezar a leer sin experiencia previa.'
  }, {
    num: 2,
    title: 'Tarot y las Cartas',
    desc: 'Significados de Arcanos Mayores y Menores, palabras clave, combinaciones y práctica.'
  }, {
    num: 3,
    title: 'Tarot por Nichos que Venden',
    desc: 'Amor, dinero, trabajo, salud: cómo especializarte en los nichos más rentables.'
  }, {
    num: 4,
    title: 'Terapéutico y Autoconocimiento',
    desc: 'Tarot como herramienta de sanación, trabajo de sombra, bloqueos y evolución personal.'
  }, {
    num: 5,
    title: 'Cómo Crear Productos Digitales',
    desc: 'Diseñá tus propias guías, cursos y recursos descargables de tarot para vender online.'
  }, {
    num: 6,
    title: 'Cómo Emprender y Vender',
    desc: 'Armá tu marca personal, atraé clientes, fijá precios y viví del tarot profesionalmente.'
  }];
  const bonus = [{
    title: 'Guía de Tiradas Rápidas',
    tagline: 'Empezá a leer HOY, sin pensar ni improvisar',
    desc: '20 tiradas listas para amor, dinero, trabajo y espiritualidad. Ideal para principiantes que no saben por dónde arrancar.',
    impact: '💥 Elimina el bloqueo inicial'
  }, {
    title: 'Diario de Lecturas',
    tagline: 'Convertí la práctica en progreso real',
    desc: 'Plantillas para registrar, analizar y mejorar tus tiradas. Vas a ver tu evolución y ganar confianza.',
    impact: '💥 Hace que no abandones'
  }, {
    title: 'Kit Profesional para Clientes',
    tagline: 'De amateur a profesional en minutos',
    desc: 'Fichas, plantillas y estructura para trabajar con clientas. Vas a dar una experiencia seria y ordenada.',
    impact: '💥 Sube tu valor percibido'
  }, {
    title: 'Interpretación Sin Bloqueos',
    tagline: 'Nunca más te quedes en blanco en una lectura',
    desc: 'Qué decir, cómo interpretar y cómo conectar cartas. Seguridad total al momento de leer.',
    impact: '💥 Elimina el miedo más grande'
  }, {
    title: 'Lecturas que Impactan (y se Pagan Mejor)',
    tagline: 'Aprendé a dar lecturas que la gente recomienda y vuelve a comprar',
    desc: 'Cómo estructurar, comunicar y generar experiencia. Vas a parecer (y ser) profesional.',
    impact: '💥 Hace que te paguen mejor'
  }, {
    title: 'Primeras Clientas en 7 Días',
    tagline: 'El sistema para conseguir tus primeras consultas pagas',
    desc: 'Dónde encontrar clientas, qué decir y cómo cerrar ventas.',
    impact: '💥 Convierte todo en dinero'
  }];
  return <section className="px-4 py-12" data-id="element-244">
      <div className="max-w-5xl mx-auto" data-id="element-245">
        <h2 className="mb-3 text-3xl font-bold text-center md:text-4xl text-brand-teal" data-id="element-246">
          Qué incluye el MegaPack
        </h2>
        <p className="mb-8 text-xl text-center text-brand-dark/70" data-id="element-247">
          Todo el material está en formato PDF, listo para descargar e imprimir.
        </p>

        <div className="grid gap-4 mb-10 md:grid-cols-2 lg:grid-cols-3" data-id="element-248">
          {tomos.map(tomo => <div key={tomo.num} className="p-6 bg-[#1a1a1a] border rounded-xl border-brand-teal/20 shadow-sm hover:shadow-md transition-shadow" data-id="element-249">
              <div className="flex items-center gap-3 mb-4" data-id="element-250">
                <div className="p-2 rounded-lg bg-brand-tealLight text-brand-teal" data-id="element-251">
                  <BookOpen className="w-6 h-6" data-id="element-252" />
                </div>
                <h3 className="font-bold text-brand-teal" data-id="element-253">TOMO {tomo.num}</h3>
              </div>
              <h4 className="mb-2 text-lg font-bold text-brand-dark" data-id="element-254">
                {tomo.title}
              </h4>
              <p className="text-brand-dark/70" data-id="element-255">{tomo.desc}</p>
            </div>)}
        </div>

        <div className="p-8 md:p-10 bg-brand-tealLight/50 rounded-2xl border border-brand-teal/10" data-id="element-256">
          <h3 className="mb-2 text-2xl font-bold text-center text-brand-teal" data-id="element-257">
            🎁 6 Bonus Exclusivos Incluidos
          </h3>
          <p className="mb-6 text-center text-lg font-bold text-brand-amber" data-id="element-258">
            Valor total:{' '}
            <span className="line-through text-brand-dark/50" data-id="element-259">$57.360</span>{' '}
            <span className="text-brand-amber" data-id="element-260">HOY GRATIS</span> 🎉
          </p>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-261">
            {bonus.map((b, i) => <div key={i} className="p-6 bg-[#1a1a1a] border border-brand-teal/20 rounded-xl shadow-sm" data-id="element-262">
                <div className="flex items-center gap-3 mb-2" data-id="element-263">
                  <FileText className="w-5 h-5 text-brand-amber" data-id="element-264" />
                  <h4 className="font-bold text-brand-dark" data-id="element-265">BONUS {i + 1}</h4>
                </div>
                <h5 className="mb-1 font-bold text-brand-teal" data-id="element-266">{b.title}</h5>
                <p className="mb-2 text-xs font-semibold italic text-brand-amber/80" data-id="element-267">
                  {b.tagline}
                </p>
                <p className="mb-3 text-sm text-brand-dark/70" data-id="element-268">{b.desc}</p>
                <p className="text-sm font-bold text-brand-teal/90" data-id="element-269">
                  {b.impact}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}